// Local Host Setup

// import axios from "axios";
// export const http = axios.create({ baseURL: "http://localhost:5009/" });
// export const barcode = "http://localhost:5009/images/barcodes/";
// export const server = "http://localhost:5009/";
// export const serverSocket = "http://localhost:5009/";
// export const apiUrlPatients = "http://localhost:5009/prijem/pacijenti/";
// export const apiUrlObradaPregled = "http://localhost:5009/obrada/pregled/";
// export const apiUrlObradaPregled_rt = "http://localhost:5009/obrada/pregled/rt/"; 
// export const apiUrlObradaPregled_lp = "http://localhost:5009/obrada/pregled/lp/"; 
// export const apiUrlObradaPregled_ag = "http://localhost:5009/obrada/pregled/ag/"; 
// export const apiUrlObradaPregled_at = "http://localhost:5009/obrada/pregled/at/"; 
// export const apiUrlNalaziPregled = "http://localhost:5009/nalazi/pregled";
// export const apiUrlNalaziPregled_rt = "http://localhost:5009/nalazi/pregled/rt/";
// export const apiUrlNalaziPregled_lp = "http://localhost:5009/nalazi/pregled/lp/";
// export const apiUrlNalaziPregled_ag = "http://localhost:5009/nalazi/pregled/ag/";
// export const apiUrlNalaziPregled_at = "http://localhost:5009/nalazi/pregled/at/";
// export const apiUrlNalaziOutbox = "http://localhost:5009/nalazi/outbox";
// export const apiUrlNalaziOutbox_rt = "http://localhost:5009/nalazi/outbox/rt/";
// export const apiUrlNalaziOutbox_lp = "http://localhost:5009/nalazi/outbox/lp/";
// export const apiUrlNalaziOutbox_ag = "http://localhost:5009/nalazi/outbox/ag/";
// export const apiUrlNalaziOutbox_at = "http://localhost:5009/nalazi/outbox/at/";
// export const apiUrlLabAssays = "http://localhost:5009/assays/lab";
// export const apiUrlAnaAssays = "http://localhost:5009/assays/ana";
// export const apiUrlControlClone = "http://localhost:5009/control/clone";
// export const apiUrlControlEdit = "http://localhost:5009/control/edit";
// export const apiUrlControlResults = "http://localhost:5009/control/results";
// export const apiUrlIntegration = "http://localhost:5009/api/pregled";
// export const apiUrlProdukt = "http://localhost:5009/inventar/produkti";
// export const apiUrlUgovor = "http://localhost:5009/inventar/ugovori";
// export const apiUrlStanje = "http://localhost:5009/inventar/stanje";
// export const apiUrlNarudzbenica = "http://localhost:5009/inventar/narudzbenice";
// export const apiUrlUlaz = "http://localhost:5009/inventar/ulazpregled";
// export const apiUrlIzlaz = "http://localhost:5009/inventar/izlazpregled";

// Server Setup

import axios from "axios";
export const http = axios.create({ baseURL: "https://sars.ilab.ba/" });
export const barcode = "https://sars.ilab.ba/images/barcodes/";
export const server = "https://sars.ilab.ba/";
export const serverSocket = "https://sars.ilab.ba/";
export const apiUrlPatients = "https://sars.ilab.ba/prijem/pacijenti/";
export const apiUrlObradaPregled = "https://sars.ilab.ba/obrada/pregled/";
export const apiUrlObradaPregled_rt = "https://sars.ilab.ba/obrada/pregled/rt/"; 
export const apiUrlObradaPregled_lp = "https://sars.ilab.ba/obrada/pregled/lp/";
export const apiUrlObradaPregled_ag = "https://sars.ilab.ba/obrada/pregled/ag/";
export const apiUrlObradaPregled_at = "https://sars.ilab.ba/obrada/pregled/at/";
export const apiUrlNalaziPregled = "https://sars.ilab.ba/nalazi/pregled";
export const apiUrlNalaziPregled_rt = "https://sars.ilab.ba/nalazi/pregled/rt/";
export const apiUrlNalaziPregled_lp = "https://sars.ilab.ba/nalazi/pregled/lp/";
export const apiUrlNalaziPregled_ag = "https://sars.ilab.ba/nalazi/pregled/ag/";
export const apiUrlNalaziPregled_at = "https://sars.ilab.ba/nalazi/pregled/at/";
export const apiUrlNalaziOutbox = "https://sars.ilab.ba/nalazi/outbox";
export const apiUrlNalaziOutbox_rt = "https://sars.ilab.ba/nalazi/outbox/rt/";
export const apiUrlNalaziOutbox_lp = "https://sars.ilab.ba/nalazi/outbox/lp/";
export const apiUrlNalaziOutbox_ag = "https://sars.ilab.ba/nalazi/outbox/ag/";
export const apiUrlNalaziOutbox_at = "https://sars.ilab.ba/nalazi/outbox/at/";
export const apiUrlLabAssays = "https://sars.ilab.ba/assays/lab";
export const apiUrlAnaAssays = "https://sars.ilab.ba/assays/ana";
export const apiUrlControlClone = "https://sars.ilab.ba/control/clone";
export const apiUrlControlEdit = "https://sars.ilab.ba/control/edit";
export const apiUrlControlResults = "https://sars.ilab.ba/control/results";
export const apiUrlIntegration = "https://sars.ilab.ba/api/pregled";
export const apiUrlProdukt = "https://sars.ilab.ba/inventar/produkti";
export const apiUrlUgovor = "https://sars.ilab.ba/inventar/ugovori";
export const apiUrlStanje = "https://sars.ilab.ba/inventar/stanje";
export const apiUrlNarudzbenica = "https://sars.ilab.ba/inventar/narudzbenice";
export const apiUrlUlaz = "https://sars.ilab.ba/inventar/ulazpregled";
export const apiUrlIzlaz = "https://sars.ilab.ba/inventar/izlazpregled";


//////////////////
// WEBPACK FOOTER
// ./config/config.js
// module id = 1wn0
// module chunks = 273